export const CREATE_SHIPPING_USER = {
    REQUEST: 'SHIPPING_USER.CREATE.REQUEST',
    SUCCESS: 'SHIPPING_USER.CREATE.SUCCESS',
    FAILED: 'SHIPPING_USER.CREATE.FAILED',
};
